import toast from "react-hot-toast";
import { getToken, getUser, toastStyle, getRestoLogin } from "../Utils/Common";
import {
  getAPICall,
  getWithParamsAPICall,
  postAPICall,
  postAPICall2,
  putAPICall,
} from "./axiosMethodCalls";

/***************************
 * FILTER
 ***************************/

const user = getUser();
const token = getToken();
const API_URL =
  getRestoLogin() === "hanamaruken"
    ? process.env.REACT_APP_BRIQUE_API
    : process.env.REACT_APP_ETTAS_API;

//POST
export const createUser = async (info, restoType) => {
  try {
    const FINAL_API_LINK =
      restoType === "hanamaruken"
        ? process.env.REACT_APP_BRIQUE_API
        : process.env.REACT_APP_ETTAS_API;
    const response = await postAPICall(FINAL_API_LINK + "users/create", {
      requester: user,
      token: token,
      username: info.username,
      password: info.password,
      confirm_password: info.confirm_password,
      full_name: info.full_name,
      email: info.email,
      role_id: info.role_id,
      branch_ids: [],
    });
    return { data: response.data };
  } catch (error) {
    if (error.response.status === 401) {
      toast.error("Unauthorized access: another device is using this account", {
        style: toastStyle(),
      });
      //   removeSession();
    }
    return { error: error.response };
  }
};

export const updateUser = async (data, restoType) => {
  try {
    const params = new URLSearchParams();
    params.append("full_name", data.full_name);
    params.append("updated_by", getUser());
    params.append("token", getToken());
    params.append("role_id", data.role_id);
    params.append("username", data.username);
    params.append("password", data.password);

    const FINAL_API_LINK =
      restoType === "hanamaruken"
        ? process.env.REACT_APP_BRIQUE_API
        : process.env.REACT_APP_ETTAS_API;
    const response = await putAPICall(
      FINAL_API_LINK + "users/update/" + data.id,
      params
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const resetPassword = async (data, userid, restoType) => {
  try {
    const params = new URLSearchParams();
    params.append("updated_by", getUser());
    params.append("token", getToken());
    params.append("password", data.password);

    const FINAL_API_LINK =
      restoType === "hanamaruken"
        ? process.env.REACT_APP_BRIQUE_API
        : process.env.REACT_APP_ETTAS_API;
    const response = await putAPICall(
      FINAL_API_LINK + "users/reset_password/" + userid.id,
      params
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const editPassword = async (id, password, token, userKey, userId) => {
  let config = {
    headers: {
      "api-key": process.env.REACT_APP_API_KEY,
      "user-key": userKey,
      "Content-Type": "application/json",
    },
  };
  try {
    const response = await postAPICall2(
      API_URL + "users/change_password",
      {
        requester: id,
        user_id: userId,
        token: token,
        password: password,
      },
      config
    );
    return { data: response };
  } catch (error) {
    if (error.response.status === 401) {
      toast.error("Unauthorized access: another device is using this account", {
        style: toastStyle(),
      });
      //   removeSession();
    }
    return { error: error.response };
  }
};

export const getSingleUser = async (id) => {
  try {
    const response = await getWithParamsAPICall(API_URL + "users/get_user", {
      requester: user,
      token: token,
      user_id: id,
    });
    return { data: response.data.data };
  } catch (error) {
    if (error.response.status === 401) {
      toast.error("Unauthorized access: another device is using this account", {
        style: toastStyle(),
      });
      //   removeSession();
    }
    return { error: error.response };
  }
};
export const getQR = async (table) => {
  try {
    const response = await getAPICall(
      API_URL + "qrcodes/show/" + table + "?table_no=" + table,
      {}
    );
    return { data: response.data.data };
  } catch (error) {
    if (error.response.status === 401) {
      toast.error("Unauthorized access: another device is using this account", {
        style: toastStyle(),
      });
      //   removeSession();
    }
    return { error: error.response };
  }
};

// export const getAllUsers = async (id) => {
//   try {
//     var payload = {
//       requester: getUser(),
//       token: getToken(),
//     };

//     const response = await getWithParamsAPICall(
//       API_URL + "users/getAll",
//       payload
//     );
//     return { data: response.data };
//   } catch (error) {
//     return { error: error.response };
//   }
// };

export const deleteUser = async (id, restoType) => {
  try {
    const params = new URLSearchParams();
    params.append("updated_by", getUser());
    params.append("token", getToken());

    const FINAL_API_LINK =
      restoType === "hanamaruken"
        ? process.env.REACT_APP_BRIQUE_API
        : process.env.REACT_APP_ETTAS_API;
    const response = await putAPICall(
      FINAL_API_LINK + "users/delete/" + id,
      params
    );
    return { data: response.data };
  } catch (error) {
    return { error: error.response };
  }
};

export const getAllRoles = async () => {
  try {
    const response = await postAPICall(API_URL + "roles/filtered_get", {
      requester: user,
      token: token,
    });
    return { data: response.data.data };
  } catch (error) {
    if (error.response.status === 401) {
      toast.error("Unauthorized access: another device is using this account");
      //   removeSession();
    }
    return { error: error.response };
  }
};
